import React from 'react';
import _ from 'lodash';
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { useTranslation } from 'react-i18next';

import { AccountStatement } from 'src/interfaces/AccountState';
import './Details.scss';
import { formatAmountToFixed } from 'src/utils/utils';

interface DetailsProps {
  accountStatement: AccountStatement[]
  selectedTimezone: string
}

function Details({ accountStatement, selectedTimezone }: DetailsProps) {
  const { t } = useTranslation();

  if (accountStatement.length === 0) {
    return (
      <div className="statement">
        <span className="statement--no-transactions">{ t('accountHistory.noTransactions') }</span>
      </div>
    );
  } else {
    return (
      <>
        {
          _.map(accountStatement, (detail) => (
            <div key={ detail.reference } className="details">
              <div className="details__row">
                <span className="details__title">{ t('accountHistory.createdAt') }</span>
                <span className="details__info">
                  { format(utcToZonedTime(detail.createdAt * 1000, selectedTimezone), 'dd MMM yyyy HH:mm:ss') }
                </span>
              </div>
              <div className="details__row">
                <span className="details__title">{ t('accountHistory.id') }</span>
                <span className="details__info">{ detail.id }</span>
              </div>
              <div className="details__row">
                <span className="details__title">{ t('accountHistory.description') }</span>
                <span className="details__info">{ detail.description }</span>
              </div>
              <div className="details__row">
                <span className="details__title">{ detail.type === 'debit' ? t('accountHistory.debit') : t('accountHistory.credit') }</span>
                <span className="details__info details__info--credit">
                  { formatAmountToFixed(detail.amount, detail.divisor, true) }
                </span>
              </div>
              <div className="details__row">
                <span className="details__title">{ t('accountHistory.balance') }</span>
                <span className="details__info details__info--credit">{ formatAmountToFixed(detail.balance, detail.divisor, true) }</span>
              </div>
            </div>
          ))
        }
      </>
    );
  }
}

export default Details;
